import React, { Component } from "react";
import { IntlProvider, FormattedMessage } from "react-intl";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import DynamicForm from "Component/DynamicForm";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import CallOutNew from "Component/Headers/callOutNew";
import { radioinputconverter } from "Component/DynamicForm/Fields/Radio";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import { ErrorMessages } from "Constants";
import { instance } from "Actions/AxiosInstance";
import Select from "react-select";
import { isSpaceInString } from "Utils";


const POSTDATA = {
  ticketcategoryid: null,
  categoryname: null,
  description: null,
  isattachmentrequired: false,
  issenderanonymous: false,
  defaultpriorityid: 3,
  isdefaultassignment: true,
  ownertypeid: 3,
  categoryowner: [],
  removedownerids: null,
  categoryapplicable: [],
  removedapplicableids: null,
};

const arrApplicableForRaiseTicketOption = [
  { displayvalue: 1, displayname: "Specific Employees" },
  { displayvalue: 2, displayname: "Group of employees" },
];

const arrTicketCategoryOwnerOption = [
  { displayvalue: 1, displayname: "Primary Manager" },
  { displayvalue: 3, displayname: "Employees" },
  { displayvalue: 4, displayname: "Department Head" },
  { displayvalue: 5, displayname: "Business Unit Head" },
];
export default class Create extends Component {
  constructor(props) {
    super(props);

    this.state = {
      intActiveStep: 0,
      arrEmployees: [],
      AllDesignation: [],
      AllBU: [],
      AllDepartment: [],
      postData: (props.postData && { ...props.postData }) || { ...POSTDATA },
      empList: [],
      selectAllEmp: false,
      selectEmp: [],
      selectBU: "",
      selectDept: "",
      selectLocation: "",
      selectOwnerEmp: "",
      categoryowner: {
        ownertypeid: (props.postData && props.postData.ownertypeid) || null,
        categoryowner:
          (props.postData &&
            props.postData.categoryowner && [
              ...props.postData.categoryowner,
            ]) ||
          [],
      },
      applicablefor: {
        applicablefor:
          (props.postData && [...props.postData.categoryapplicable]) || [],
      },
      pvsCtgOwner: {
        ownertypeid: (props.postData && props.postData.ownertypeid) || null,
        categoryowner:
          (props.postData &&
            props.postData.categoryowner && [
              ...props.postData.categoryowner,
            ]) ||
          [],
      },
      pvsApplicableFor:
        (props.postData && [...props.postData.categoryapplicable]) || [],
    };

    this.updatePostData = this.updatePostData.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.ctgApplicableFor = this.ctgApplicableFor.bind(this);
    this.ctgOwnerFor = this.ctgOwnerFor.bind(this);
    this.ctgOwnerOnChange = this.ctgOwnerOnChange.bind(this);
    this.onChangeDefaultAssignment = this.onChangeDefaultAssignment.bind(this);
    this.getAllEmp = this.getAllEmp.bind(this);
    this.getBusinessUnit = this.getBusinessUnit.bind(this);
    this.getDepartment = this.getDepartment.bind(this);
    this.getDesignationData = this.getDesignationData.bind(this);
  }

  componentDidMount() {
    this.getAllEmp();
    this.getBusinessUnit();
    this.getDepartment();
    this.getDesignationData();

    const { applicablefor, categoryowner } = { ...this.state };
    const selectAllEmp = applicablefor.applicablefor.some(
      (objApplicableFor) => objApplicableFor.applicablefortypeid == 1,
    )
      ? true
      : false;

    const selectFor =
      applicablefor.applicablefor.length > 0
        ? applicablefor.applicablefor.some(
            (objApplicableFor) =>
              objApplicableFor.applicablefortypeid == 1 ||
              objApplicableFor.applicablefortypeid == 0,
          )
          ? arrApplicableForRaiseTicketOption[0]
          : arrApplicableForRaiseTicketOption[1]
        : null;

    const pvsSelectFor = (selectFor && { ...selectFor }) || null;
    const ctgOwner = arrTicketCategoryOwnerOption.find(
      (option) => option.displayvalue == categoryowner.ownertypeid,
    );

    this.setState({
      selectAllEmp,
      selectFor,
      pvsSelectFor,
      ctgOwner,
    });
  }

  getAllEmp() {
    instance
      .post(`subscription/getemployeelist`)
      .then((result) => {
        const { applicablefor } = { ...this.state };

        const selectOwnerEmp = result.data.result.filter(
          (emp) =>
            this.state.categoryowner.categoryowner.some(
              (owner) => owner.employeeid == emp.displayvalue,
            ) || false,
        );

        const defaultowner = result.data.result.filter(
          (emp) =>
            this.state.categoryowner.categoryowner.some(
              (owner) =>
                owner.employeeid == emp.displayvalue && owner.isdefaultowner,
            ) || false,
        );

        const objAllApplicableEmployee =
          (applicablefor.applicablefor &&
            applicablefor.applicablefor.find(
              (obj) => obj.applicablefortypeid == 0,
            )) ||
          {};

        const selectEmp = result.data.result.filter(
          (emp) =>
            objAllApplicableEmployee.applicableforids &&
            objAllApplicableEmployee.applicableforids
              .split(",")
              .some((id) => id == emp.displayvalue),
        );

        this.setState({
          empList: result.data.result,
          selectOwnerEmp,
          selectEmp,
          defaultowner,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  updatePostData(key, value) {
    this.setState({
      postData: { ...this.state.postData, [key]: value },
    });
  }

  onCancel = () => {
    this.props.enqueueSnackbar(` Are you sure, you would lost your progress?`, {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            this.setState(
              {
                postData: { ...POSTDATA },
              },
              () => {
                this.props.history.push(`${this.props.match.path}`);
                this.props.closeSnackbar();
              },
            );
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  };

  validateRequest(objRequest) {
    if (!objRequest.categoryname) {
      this.props.enqueueSnackbar("Please enter category name", {
        variant: "error",
      });
      return false;
    }

    if (objRequest.categoryname && !isSpaceInString(objRequest.categoryname)) {
      objRequest.categoryname = objRequest.categoryname.trim();
    }

    if (this.state.selectFor == null) {
      this.props.enqueueSnackbar(
        "Please select category applicable for employees",
        {
          variant: "error",
        },
      );
      return false;
    }

    if (
      objRequest.categoryapplicable.every(
        (objApplicable) =>
          !objApplicable.applicableforids &&
          objApplicable.applicablefortypeid != 1,
      )
    ) {
      this.props.enqueueSnackbar(
        "Please select category applicable for employees",
        {
          variant: "error",
        },
      );
      return false;
    }

    if (
      !objRequest.ownertypeid ||
      (objRequest.ownertypeid == 3 && !objRequest.categoryowner.length)
    ) {
      this.props.enqueueSnackbar("Please select category owner", {
        variant: "error",
      });
      return false;
    }

    return true;
  }

  onSave() {
    let { postData } = { ...this.state };
    const {
      ownertypeid,
      categoryowner,
      categoryapplicable,
      removedapplicableids,
      removedownerids,
    } = this.getRemovedOwnerAndApplicableFor();

    let intSquenceId = 1;
    categoryowner &&
      categoryowner.forEach((objOwner) => {
        objOwner.roundsequence = intSquenceId;
        intSquenceId += 1;
      });
    postData = {
      ...postData,
      ownertypeid,
      categoryowner,
      categoryapplicable,
      removedapplicableids,
      removedownerids,
    };

    if (!this.validateRequest(postData)) return;

    instance
      .post("helpdesk/createticketcategory", postData)
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, {
          variant: "success",
        });
        this.props.getAllTicketCategory(true);
        this.setState({
          postData: { ...POSTDATA },
        });
        this.props.history.push(`${this.props.match.path}`);
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getRemovedOwnerAndApplicableFor() {
    const {
      applicablefor,
      categoryowner,
      pvsApplicableFor,
      pvsSelectFor,
      selectFor,
      pvsCtgOwner,
    } = {
      ...this.state,
    };

    let categoryapplicable = [];
    let removedapplicableids = [];
    const removedownerids = [];

    let objPvsApplicable = {};
    applicablefor.applicablefor.forEach((objApplicable) => {
      objPvsApplicable = pvsApplicableFor.find(
        (objPropsApplicable) =>
          objPropsApplicable.applicablefortypeid ==
          objApplicable.applicablefortypeid,
      );
      if (objPvsApplicable) {
        if (objPvsApplicable.applicablefortypeid == 1) {
          categoryapplicable.push({
            applicablefortypeid: objApplicable.applicablefortypeid,
            applicableforids: null,
            categoryapplicableid: objPvsApplicable.categoryapplicableid,
          });

          return;
        }
        const arrRemovedapplicableids = objPvsApplicable.applicableforids
          .split(",")
          .filter(
            (pvsIds) =>
              !objApplicable.applicableforids
                .split(",")
                .some((ids) => pvsIds == ids),
          );

        const arrApplicableForIds = objApplicable.applicableforids
          .split(",")
          .filter(
            (pvsIds) => !arrRemovedapplicableids.some((ids) => pvsIds == ids),
          );

        arrApplicableForIds &&
          categoryapplicable.push({
            applicablefortypeid: objApplicable.applicablefortypeid,
            applicableforids: arrApplicableForIds.join(","),
            categoryapplicableid: objPvsApplicable.categoryapplicableid,
          });

        if (arrRemovedapplicableids.length) {
          removedapplicableids.push(objPvsApplicable.categoryapplicableid);
        }
      } else {
        categoryapplicable = applicablefor.applicablefor;
        removedapplicableids = [];
      }
    });

    if (pvsSelectFor && pvsSelectFor.displayvalue != selectFor.displayvalue) {
      pvsApplicableFor.forEach((objApplicable) => {
        removedapplicableids.push(objApplicable.categoryapplicableid);
      });
    } else if (
      pvsSelectFor &&
      pvsSelectFor.displayvalue == selectFor.displayvalue
    ) {
      pvsApplicableFor.forEach((objApplicable) => {
        if (
          categoryapplicable.every(
            (objCtgApp) =>
              objCtgApp.applicablefortypeid !=
              objApplicable.applicablefortypeid,
          )
        ) {
          removedapplicableids.push(objApplicable.categoryapplicableid);
        }
      });
    }

    if (
      pvsCtgOwner.ownertypeid != categoryowner.ownertypeid &&
      pvsCtgOwner.ownertypeid == 3
    ) {
      removedownerids.push(
        ...pvsCtgOwner.categoryowner.map((owner) => owner.categoryownerid),
      );
      categoryowner.categoryowner = null;
    } else {
      removedownerids.push(
        ...pvsCtgOwner.categoryowner
          .filter(
            (pvsOwner) =>
              !(
                categoryowner.categoryowner &&
                categoryowner.categoryowner.some(
                  (owner) => owner.employeeid == pvsOwner.employeeid,
                )
              ),
          )
          .map((delOwner) => delOwner.categoryownerid),
      );

      categoryowner.categoryowner =
        categoryowner.categoryowner &&
        categoryowner.categoryowner.filter(
          (owner) =>
            !removedownerids.some(
              (ownerid) => owner.categoryownerid == ownerid,
            ),
        );
    }

    return {
      categoryapplicable,
      categoryowner:
        categoryowner.ownertypeid != 3 ? null : categoryowner.categoryowner,
      ownertypeid: categoryowner.ownertypeid,
      removedapplicableids: removedapplicableids.join(",") || null,
      removedownerids: removedownerids.join(",") || null,
    };
  }

  getBusinessUnit() {
    const data = {
      featurekey: "ticketCategory",
    };
    instance
      .post(`subscription/allbusinessunit`, data)
      .then((result) => {
        const applicablefor = { ...this.state.applicablefor };
        const objAllApplicabeBU =
          (applicablefor.applicablefor &&
            applicablefor.applicablefor.find(
              (obj) => obj.applicablefortypeid == 2,
            )) ||
          {};

        const selectBU = result.data.result.filter(
          (bu) =>
            objAllApplicabeBU.applicableforids &&
            objAllApplicabeBU.applicableforids
              .split(",")
              .some((id) => id == bu.displayvalue),
        );
        this.setState({ AllBU: result.data.result, selectBU });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getDepartment() {
    const data = {
      featurekey: "ticketCategory",
    };
    instance
      .post(`subscription/departmentbybuidwithglobal`, data)
      .then((result) => {
        const applicablefor = { ...this.state.applicablefor };
        const AllDepartment = result.data.result.map((objOption) => ({
          label: objOption.label,
          options: (objOption.options && JSON.parse(objOption.options)) || [],
        }));

        const objAllApplicabeDep =
          (applicablefor.applicablefor &&
            applicablefor.applicablefor.find(
              (obj) => obj.applicablefortypeid == 3,
            )) ||
          {};

        const selectDept = [];

        AllDepartment.forEach((dept) => {
          selectDept.push(
            ...dept.options.filter(
              (opt) =>
                objAllApplicabeDep.applicableforids &&
                objAllApplicabeDep.applicableforids
                  .split(",")
                  .some((id) => id == opt.value),
            ),
          );
        });

        this.setState({ AllDepartment, selectDept });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getDesignationData() {
    instance
      .get(`subscription/alldesignation`)
      .then((result) => {
        const applicablefor = { ...this.state.applicablefor };
        const objAllApplicabeDES =
          (applicablefor.applicablefor &&
            applicablefor.applicablefor.find(
              (obj) => obj.applicablefortypeid == 4,
            )) ||
          {};

        const selectDes = result.data.result.filter(
          (des) =>
            objAllApplicabeDES.applicableforids &&
            objAllApplicabeDES.applicableforids
              .split(",")
              .some((id) => id == des.displayvalue),
        );
        this.setState({ AllDesignation: result.data.result, selectDes });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  ctgApplicableFor(val) {
    this.setState({
      selectFor: val,
      selectEmp: "",
      selectGrp: "",
      selectBU: "",
      selectDept: "",
      selectDes: "",
    });
    if (val.displayvalue == 1) {
      const applicablefor = {
        applicablefor: [
          {
            applicablefortypeid: 1,
            applicableforids: null,
          },
        ],
      };
      this.setState({
        applicablefor,
        selectEmp: this.state.empList,
        selectAllEmp: true,
      });
    } else if (val.displayvalue == 2) {
      let applicablefor = {};
      applicablefor = {
        applicablefor: [],
      };
      this.setState({ applicablefor }, () => {});
    }
  }

  empOnChange(val) {
    let applicableforids =
      (val && val.map((objEmp) => objEmp.displayvalue).join()) || "";

    applicableforids = applicableforids == "" ? null : applicableforids;

    const applicablefor = { applicablefor: [] };

    applicablefor.applicablefor = [
      {
        applicablefortypeid: 0,
        applicableforids,
      },
    ];
    this.setState({ applicablefor, selectEmp: val });
  }

  selectAllEmpOnChange() {
    let applicablefor = {
      applicablefor: [
        {
          applicablefortypeid: 1,
          applicableforids: null,
        },
      ],
    };

    const selectEmp = !this.state.selectAllEmp ? this.state.empList : [];
    this.setState(
      { selectAllEmp: !this.state.selectAllEmp, selectEmp, applicablefor },
      () => {
        if (this.state.selectAllEmp == false) {
          applicablefor = {
            applicablefor: [
              {
                applicablefortypeid: 0,
                applicableforids: null,
              },
            ],
          };
          this.setState({ applicablefor });
        }
      },
    );
  }

  buOnChange(val) {
    if (val && val.length > 0) {
      const { applicablefor } = this.state;
      const indexloc = applicablefor.applicablefor.findIndex(
        (x) => x.applicablefortypeid == 2,
      );
      if (indexloc != -1) {
        applicablefor.applicablefor.splice(indexloc, 1);
      }
      const applicableforids = val.map((objBU) => objBU.displayvalue).join(",");

      const index = applicablefor.applicablefor.findIndex(
        (x) => x.applicablefortypeid == 2,
      );

      const objectData = {
        applicablefortypeid: 2,
        applicableforids,
      };

      if (index >= 0) applicablefor.applicablefor[index] = objectData;
      else applicablefor.applicablefor.push(objectData);

      this.setState({ applicablefor, selectBU: val });
    } else {
      const { applicablefor } = this.state;
      const index = applicablefor.applicablefor.findIndex(
        (x) => x.applicablefortypeid == 2,
      );

      applicablefor.applicablefor.splice(index, 1);
      this.setState({ applicablefor, selectBU: val });
    }
  }

  deptOnChange(val) {
    const { applicablefor } = this.state;
    if (val) {
      const indexloc = applicablefor.applicablefor.findIndex(
        (x) => x.applicablefortypeid == 3,
      );
      if (indexloc != -1) {
        applicablefor.applicablefor.splice(indexloc, 1);
      }
      const applicableforids = val.map((objDept) => objDept.value).join(",");

      const index = applicablefor.applicablefor.findIndex(
        (x) => x.applicablefortypeid == 3,
      );

      const objectData = {
        applicablefortypeid: 3,
        applicableforids,
      };

      if (index >= 0) applicablefor.applicablefor[index] = objectData;
      else applicablefor.applicablefor.push(objectData);

      this.setState({ applicablefor, selectDept: val });
    } else {
      const index = applicablefor.applicablefor.findIndex(
        (x) => x.applicablefortypeid == 3,
      );
      applicablefor.applicablefor.splice(index, 1);
      this.setState({ applicablefor, selectDept: val });
    }
  }

  desOnChange(val) {
    if (val && val.length > 0) {
      const { applicablefor } = this.state;
      const indexloc = applicablefor.applicablefor.findIndex(
        (x) => x.applicablefortypeid == 4,
      );
      if (indexloc != -1) {
        applicablefor.applicablefor.splice(indexloc, 1);
      }
      const applicableforids = val
        .map((objDes) => objDes.displayvalue)
        .join(",");

      const index = applicablefor.applicablefor.findIndex(
        (x) => x.applicablefortypeid == 4,
      );

      const objectData = {
        applicablefortypeid: 4,
        applicableforids,
      };

      if (index >= 0) applicablefor.applicablefor[index] = objectData;
      else applicablefor.applicablefor.push(objectData);

      this.setState({ applicablefor, selectDes: val });
    } else {
      const { applicablefor } = this.state;
      const index = applicablefor.applicablefor.findIndex(
        (x) => x.applicablefortypeid == 4,
      );

      applicablefor.applicablefor.splice(index, 1);
      this.setState({ applicablefor, selectDes: val });
    }
  }

  ctgOwnerFor(val) {
    this.setState({
      ctgOwner: val,
      selectPM: "",
      selectBUHead: "",
      selectDeptHead: "",
    });
    if (val && val.displayvalue == 3) {
      const categoryowner = {
        ownertypeid: 3,
        categoryowner: [],
      };
      this.setState({
        categoryowner,
      });
    } else {
      const categoryowner = {
        ownertypeid: val && val.displayvalue,
        categoryowner: null,
      };
      this.setState({ categoryowner });
    }
  }

  ctgOwnerOnChange(val) {
    const categoryowner = { ...this.state.categoryowner };
    let defaultowner = [...this.state.defaultowner];

    categoryowner.categoryowner =
      val &&
      val.map((objEmp) => ({
        employeeid: objEmp.displayvalue,
        isdefaultowner: false,
        roundsequence: 0,
      }));

    defaultowner = defaultowner.filter((objDfOwner) =>
      categoryowner.categoryowner.some(
        (objOwner) => objDfOwner.displayvalue == objOwner.employeeid,
      ),
    );

    this.setState({ categoryowner, defaultowner, selectOwnerEmp: val });
  }

  onChangeDefaultAssignment(value) {
    const categoryowner = { ...this.state.categoryowner };

    categoryowner.categoryowner.forEach((owner) => {
      if (owner.employeeid == value.displayvalue) {
        owner.isdefaultowner = true;
      }
    });

    this.setState({ categoryowner, defaultowner: value });
  }

  renderApplicableFor() {
    return (
      <div>
        {this.state.selectFor && (
          <div style={{ width: 250 }}>
            {this.state.selectFor.displayvalue == 1 ? (
              <div className="margin-bottom-16">
                <p className="input-label">Employees</p>
                <div className="margin-bottom-8">
                  <Select
                    class="form-control"
                    autofocus
                    placeholder="Select Employee"
                    isMulti
                    isDisabled={this.state.selectAllEmp}
                    options={this.state.empList.filter(
                      (x) => x.displayvalue != -99,
                    )}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    onChange={this.empOnChange.bind(this)}
                    value={
                      this.state.selectAllEmp
                        ? [{ displayname: "all", displayvalue: -98 }]
                        : this.state.selectEmp
                    }
                  />
                  {this.state.errorEmp ? (
                    <span className="validation-text">
                      *Please select Employees
                    </span>
                  ) : null}
                </div>
                <Checkbox
                  checked={this.state.selectAllEmp}
                  onChange={this.selectAllEmpOnChange.bind(this)}
                  value={this.state.selectAllEmp}
                  color="primary"
                  className="custom-checkbox floatleft"
                />
                <span className="input-label">Select All Employees</span>
              </div>
            ) : this.state.selectFor.displayvalue == 2 ? (
              <div>
                <div className="margin-bottom-20">
                  <p className="input-label">Business Unit</p>
                  <Select
                    class="form-control"
                    autofocus
                    placeholder="Select Business Unit"
                    isMulti
                    options={this.state.AllBU}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    onChange={this.buOnChange.bind(this)}
                    value={this.state.selectBU}
                  />
                </div>
                <div className="margin-bottom-20">
                  <p className="input-label">Department</p>
                  <Select
                    class="form-control"
                    autofocus
                    placeholder="Select Department"
                    isMulti
                    options={this.state.AllDepartment}
                    onChange={this.deptOnChange.bind(this)}
                    value={this.state.selectDept}
                  />
                </div>
                <div className="margin-bottom-20">
                  <p className="input-label">Designation</p>
                  <Select
                    class="form-control"
                    autofocus
                    placeholder="Select Designation"
                    isMulti
                    options={this.state.AllDesignation}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    onChange={this.desOnChange.bind(this)}
                    value={this.state.selectDes}
                  />
                </div>
              </div>
            ) : null}
          </div>
        )}
      </div>
    );
  }

  renderCtgOwner() {
    return (
      this.state.categoryowner.ownertypeid == 3 && (
        <div>
          <div className="margin-bottom-16">
            <p className="input-label">Employees</p>
            <div className="margin-bottom-8" style={{ width: 250 }}>
              <Select
                class="form-control"
                autofocus
                placeholder="Select Employee"
                isMulti
                options={this.state.empList.filter(
                  (x) => x.displayvalue != -99,
                )}
                getOptionLabel={(option) => option.displayname}
                getOptionValue={(option) => option.displayvalue}
                onChange={this.ctgOwnerOnChange.bind(this)}
                value={this.state.selectOwnerEmp}
              />
            </div>
          </div>
          <p className="normal-dark-secondary t-bold margin-bottom-8">
            Default ticket assignment
          </p>
          <Grid container>
            <Grid item sm={12} md={5}>
              <div className="floatleft width50">
                <DynamicForm
                  className="width100"
                  fields={radioinputconverter({
                    value: this.state.postData.isdefaultassignment,
                    label: "Specific employee",
                  })}
                  onChange={() =>
                    this.updatePostData("isdefaultassignment", true)
                  }
                />
              </div>
              <div className="floatleft width50">
                <DynamicForm
                  className="width100"
                  fields={radioinputconverter({
                    value: !this.state.postData.isdefaultassignment,
                    label: "Round robin",
                  })}
                  onChange={() =>
                    this.updatePostData("isdefaultassignment", false)
                  }
                />
              </div>
            </Grid>
            <Grid item sm={12} md={7}>
              <CallOutNew
                classnames="bg-light-blue width100"
                header="A round robin assignment rule allows you to equally distribute new tickets without having to manually assign them using rotation."
                emoji="📌"
                textcolor="#1e8ced"
              />
            </Grid>
          </Grid>

          <div style={{ marginBottom: 80, width: 250 }}>
            {this.state.postData.isdefaultassignment && (
              <Select
                isMulti={false}
                onChange={this.onChangeDefaultAssignment}
                options={this.state.selectOwnerEmp}
                getOptionLabel={(option) => option.displayname}
                getOptionValue={(option) => option.displayvalue}
                isClearable={true}
                value={this.state.defaultowner}
                label="Default ticket owners"
              />
            )}
          </div>
        </div>
      )
    );
  }

  render() {
    const { postData } = this.state;
    return (
      <div className="content-outer-wrapper" style={{ marginBottom: 64 }}>
        <p className="large-text-dark-secondary margin-bottom-16 t-bold">
          Create new ticket category
        </p>

        <div item xs={12} md={12} sm={12}>
          <div>
            <div style={{ width: 250 }}>
              <DynamicForm
                fields={textinputconverter({
                  value: postData.categoryname,
                  placeholder: "Eg: Stationary needs",
                  label: "Category name",
                })}
                onChange={(value) => {
                  this.updatePostData("categoryname", value);
                }}
              />
              <DynamicForm
                fields={textareainputconverter({
                  value: postData.description,
                  placeholder: "Let other know the purpose of this category.",
                  label: "Description",
                })}
                onChange={(value) => {
                  this.updatePostData("description", value);
                }}
              />
            </div>
            <div style={{ width: 440 }}>
              <DynamicForm
                fields={checkboxinputconverter({
                  value: postData.isattachmentrequired,
                  placeholder: "",
                  label:
                    "Make attachments mandatory to raise ticket in this category",
                })}
                onChange={(value) => {
                  this.updatePostData("isattachmentrequired", value);
                }}
              />
              <DynamicForm
                fields={checkboxinputconverter({
                  value: postData.issenderanonymous,
                  placeholder: "",
                  label:
                    "Allow employee to make anonymous ticket in this category",
                })}
                onChange={(value) => {
                  this.updatePostData("issenderanonymous", value);
                }}
              />
            </div>
            <p className="input-label">
              Select default priority for this category
            </p>
            <DynamicForm
              className="width100"
              fields={radioinputconverter({
                value: postData.defaultpriorityid == 1,
                label: "High",
              })}
              onChange={() => this.updatePostData("defaultpriorityid", 1)}
            />
            <DynamicForm
              className="width100"
              fields={radioinputconverter({
                value: postData.defaultpriorityid == 2,
                label: "Moderate",
              })}
              onChange={() => this.updatePostData("defaultpriorityid", 2)}
            />
            <DynamicForm
              className="width100"
              fields={radioinputconverter({
                value: postData.defaultpriorityid == 3,
                label: "Low",
              })}
              onChange={() => this.updatePostData("defaultpriorityid", 3)}
            />

            <p className="input-label">
              Select who can raise a ticket in this category
            </p>
            <div style={{ marginBottom: 16, width: 250 }}>
              <Select
                class="form-control"
                autofocus
                placeholder="Select"
                options={arrApplicableForRaiseTicketOption}
                getOptionLabel={(option) => option.displayname}
                getOptionValue={(option) => option.displayvalue}
                onChange={this.ctgApplicableFor.bind(this)}
                value={this.state.selectFor}
              />
            </div>

            {this.renderApplicableFor()}

            <Grid container>
              <Grid item sm={12} md={5}>
                <p className="input-label">
                  Select ticket owners for this category
                </p>
                <div style={{ marginBottom: 16, width: 250 }}>
                  <Select
                    isMulti={false}
                    onChange={this.ctgOwnerFor}
                    options={arrTicketCategoryOwnerOption}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    isClearable={true}
                    value={this.state.ctgOwner}
                    label="Ticket owners"
                  />
                </div>
              </Grid>
              <Grid item sm={12} md={7}>
                <CallOutNew
                  classnames="bg-light-blue width100"
                  header="Only ticket owners will be able to collaborate on resolving tickets in that category. This includes ‘Looping in’ and ‘mentioning in notes’."
                  emoji="📌"
                  textcolor="#1e8ced"
                />
              </Grid>
            </Grid>
            {this.renderCtgOwner()}
          </div>
        </div>

        <div
          className="width100"
          style={{
            position: "fixed",
            left: 0,
            background: "white",
            bottom: 0,
            padding: 10,
            borderTop: "1px solid #d4d4d4",
            zIndex: 0,
          }}
        >
          <div>
            <div className="floatleft" style={{ marginLeft: 304 }}>
              <Button
                className="btn btn-secondary-md-blue margin-right-16"
                variant="contained"
                onClick={this.onCancel}
              >
                Cancel
              </Button>
            </div>
            <div className="floatright" style={{ marginRight: 72 }}>
              <div>
                <Button
                  className="btn btn-primary-md-blue"
                  variant="contained"
                  onClick={() => this.onSave()}
                >
                  Save
                </Button>
              </div>
            </div>
            <div className="clearfloat"></div>
          </div>
        </div>
      </div>
    );
  }
}
